import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HandoverChain } from '../models/handover-chain.model';

@Injectable({ providedIn: 'root' })
export class TestCaseHandoverService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  list(projectId: string, testCaseId: string): Observable<HandoverChain> {
    return this.http.get<HandoverChain>(`${this.base}/${projectId}/test-cases/${testCaseId}/handovers`);
  }

  handOff(projectId: string, testCaseId: string, userId: string): Observable<HandoverChain> {
    return this.http.post<HandoverChain>(`${this.base}/${projectId}/test-cases/${testCaseId}/handovers`, {
      userId,
    });
  }

  close(projectId: string, testCaseId: string): Observable<HandoverChain> {
    return this.http.patch<HandoverChain>(`${this.base}/${projectId}/test-cases/${testCaseId}/handovers/close`, {});
  }

  reopen(projectId: string, testCaseId: string): Observable<HandoverChain> {
    return this.http.patch<HandoverChain>(`${this.base}/${projectId}/test-cases/${testCaseId}/handovers/reopen`, {});
  }
}
